/**
 * Created by toor on 17-10-10.
 */

let toString = Object.prototype.toString();

function isUndefined(value) {
	return "undefined" == typeof value
}

function isDefined(value) {
	return "undefined" != typeof value
}

function isObject(value) {
	return null != value && "object" == typeof value
}

function isString(value) {
	return "string" == typeof value
}

function isNumber(value) {
	return "number" == typeof value
}

function isDate(value) {
	return "[object Date]" == toString.apply(value)
}

function isArray(value) {
	return "[object Array]" == toString.apply(value)
}

function isFunction(value) {
	return "function" == typeof value
}

function int(str) {
	return parseInt(str, 10)
}
function toBoolean(value) {
	if (value && 0 !== value.length) {
		let v = lowercase("" + value);
		value = !("f" == v || "0" == v || "false" == v || "no" == v || "n" == v || "[]" == v)
	} else value = !1;
	return value
}

let lowercase = function (string) {
	return isString(string) ? string.toLowerCase() : string
}, uppercase = function (string) {
	return isString(string) ? string.toUpperCase() : string
};

function jsonFilter() {
	return function (object) {
		return JSON.stringify(object);
	}
}

function limitToFilter() {
	return function (input, limit) {
		if (!isArray(input) && !isString(input)) return input;
		if (limit = int(limit), isString(input)) return limit ? limit >= 0 ? input.slice(0, limit) : input.slice(limit, input.length) : "";
		let i, n, out = [];
		for (limit > input.length ? limit = input.length : limit < -input.length && (limit = -input.length), limit > 0 ? (i = 0, n = limit) : (i = input.length + limit, n = input.length); n > i; i++) out.push(input[i]);
		return out
	}
}

function orderByFilter($parse) {
	return function (array, sortPredicate, reverseOrder) {
		function comparator(o1, o2) {
			for (let i = 0; i < sortPredicate.length; i++) {
				let comp = sortPredicate[i](o1, o2);
				if (0 !== comp) return comp
			}
			return 0
		}

		function reverseComparator(comp, descending) {
			return toBoolean(descending) ? function (a, b) {
					return comp(b, a)
				} : comp
		}

		function compare(v1, v2) {
			let t1 = typeof v1,
				t2 = typeof v2;
			return t1 == t2 ? ("string" == t1 && (v1 = v1.toLowerCase(), v2 = v2.toLowerCase()), v1 === v2 ? 0 : v2 > v1 ? -1 : 1) : t2 > t1 ? -1 : 1
		}

		if (!isArray(array)) return array;
		if (!sortPredicate) return array;
		sortPredicate = isArray(sortPredicate) ? sortPredicate : [sortPredicate], sortPredicate = map(sortPredicate, function (predicate) {
			let descending = !1,
				get = predicate || identity;
			return isString(predicate) && (("+" == predicate.charAt(0) || "-" == predicate.charAt(0)) && (descending = "-" == predicate.charAt(0), predicate = predicate.substring(1)), get = $parse(predicate)), reverseComparator(function (a, b) {
				return compare(get(a), get(b))
			}, descending)
		});
		for (var arrayCopy = [], i = 0; i < array.length; i++) arrayCopy.push(array[i]);
		return arrayCopy.sort(reverseComparator(comparator, reverseOrder))
	}
}

// Vue.filter('json', jsonFilter);
// Vue.filter('limitTo', limitToFilter);
// Vue.filter('orderBy', orderByFilter);
// Vue.filter('lowercase', lowercase);
// Vue.filter('uppercase', uppercase);
export {
	jsonFilter,
	limitToFilter,
	orderByFilter,
	lowercase,
	uppercase
}



// WEBPACK FOOTER //
// ./src/modules/filter/common.js